'use client'
import {styled} from "styled-components"

export const StyledDescription = styled.pre`
  min-height: 350px;
  //width: 1000px;
  margin: 0 auto;
  padding: 6px;
  white-space: pre-wrap;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
`
